import { BMEmptyStateProps } from "@traveloka/district-bloom/js/components/EmptyState/BMEmptyState";
import { ComponentProps } from "react";
import { ImageEntry } from "../../../types";
import ErrorSectionLarge from "./ErrorSectionLarge";

export function getErrorSectionCustomImage(image?: ImageEntry) {
  if (!image?.link) return undefined;
  return { url: image.link, alt: image.altText };
}

export function getErrorSectionIllustration(
  illustration: BMEmptyStateProps["illustration"]
) {
  return illustration ?? "GENERAL_ERROR";
}

export function getErrorSectionButtons(
  button: ComponentProps<typeof ErrorSectionLarge>["button"]
): {
  mainCTA: BMEmptyStateProps["mainCTA"];
  secondaryCTA: BMEmptyStateProps["secondaryCTA"];
} {
  const buttons = Array.isArray(button) ? button : button ? [button] : [];
  const primary = buttons.find((btn) => btn.type !== "SECONDARY");
  const secondary = buttons.find((btn) => btn.type === "SECONDARY");

  return {
    mainCTA: primary ? { ...primary, size: "LARGE" } : undefined,
    secondaryCTA: secondary ? { ...secondary, size: "LARGE" } : undefined,
  };
}
